import { render } from "./closedTickets.vue?vue&type=template&id=48ff8d2c&scoped=true"
import script from "./closedTickets.vue?vue&type=script&lang=js"
export * from "./closedTickets.vue?vue&type=script&lang=js"

import "./closedTickets.vue?vue&type=style&index=0&id=48ff8d2c&scoped=true&lang=scss"
import "./closedTickets.vue?vue&type=style&index=1&id=48ff8d2c&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ff8d2c"]])

export default __exports__